import { computed, defineComponent } from 'vue';
import { useRoute } from 'vue-router';

export default defineComponent({
  name: 'BreadcrumbComponent',
  setup: () => {
    const route = useRoute();

    interface Breadcrumb {
      display: string;
      link: string;
      active: boolean;
    }

    const params = computed(() => getParams());
    const paths = computed(() => getPaths());
    const breadcrumbs = computed(() => getBreadcrumb());

    // example: /user/:id
    const getParams = () => {
      const paramArray: Array<{ key: string, val: string }> = [];

      for (const key in route.params) {
        const param = route.params[key as keyof typeof route.params] as string;
        paramArray.push({ key: key, val: param });
      }

      return paramArray;
    };

    const getPaths = () => {
      const usedParamKeys: string[] = [];

      return [...new Set(route.path.split('/'))]
        .reduce((pathArray: Array<{ key: string, link: string }>, path, index) => {
          if (index === 0) {
            pathArray.push({ key: `/${path}`, link: `/${path}` });
          } else {
            const previous = pathArray[index - 1];
            const param = params.value.find(m => m.val === path && !usedParamKeys.includes(m.key));

            if (param) {
              usedParamKeys.push(param.key);
              pathArray.push({ key: `${previous.key}/:${param?.key}`.replace('//', '/'), link: `${previous.link}/${param?.val}`.replace('//', '/') });
            } else {
              pathArray.push({ key: `${previous.key}/${path}`.replace('//', '/'), link: `${previous.link}/${path}`.replace('//', '/') });
            }
          }

          return pathArray;
        }, []);
    };

    const getBreadcrumb = () => {
      return paths.value.reduce((breadcrumb: Breadcrumb[], path) => {
        breadcrumb.push({
          display: getTitle(path.key),
          link: path.link,
          active: (path.link === route.path) ? true : false
        });

        return breadcrumb;
      }, []);
    };

    const getTitle = (path: string) => {
      const titles = [
        { path: '/', name: 'home' },
        { path: '/announcements', name: 'breadcrumb.announcement' },
        { path: '/videos', name: 'breadcrumb.video' },
        { path: '/project', name: 'breadcrumb.project' },
        { path: '/province', name: 'breadcrumb.province' },
        { path: '/psc', name: 'breadcrumb.psc' },
        { path: '/documents', name: 'breadcrumb.document' },
        { path: '/others', name: 'breadcrumb.other' },
      ];

      if (path.endsWith(':id')) {
        return  'breadcrumb.detail';
      }

      return titles.find(m => m.path === path)?.name;
    };

    return {
      breadcrumbs,
    };
  }
});
